var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6668H14M4 12.0002V7.3335M6.66667 12.0002V7.3335M9.33333 12.0002V7.3335M12 12.0002V7.3335M8 1.3335L13.3333 4.66683H2.66667L8 1.3335Z",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmark);
export default __webpack_public_path__ + "static/media/landmark.d8d73e9ac4c854148ec3a033e29f5e20.svg";
export { ForwardRef as ReactComponent };